class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          this.updateDrawerProperty();
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));
    this.updateDrawerProperty();
    this.open();
  }

  updateDrawerProperty(){
    setTimeout(() => {
      let sampleWrapper = this.querySelector('cart-sample-selector')
      if(sampleWrapper){
        this.style.setProperty('--semple-slide-right',(sampleWrapper.hasAttribute('is-active')) ? "100%" : "0%");
        this.style.setProperty('--semple-width',(sampleWrapper.dataset.width));
        sampleWrapper.classList.toggle('is-active',sampleWrapper.hasAttribute('is-active'));
      }
    }, 500);
    
    setTimeout(() => {
      let discountsHolidaysWrapper = this.querySelector('cart-drawer-discounts-holidays')
      let recommendationHoliday = this.querySelector('cart-recommendations')
      if(discountsHolidaysWrapper){
        this.style.setProperty('--discounts-holidays-slide-right',(discountsHolidaysWrapper.hasAttribute('is-active')) ? "100%" : "0%");
        this.style.setProperty('--discounts-holidays-width',(discountsHolidaysWrapper.dataset.width));        
        this.style.setProperty('--recommendatio-holiday',(recommendationHoliday.dataset.width));
        discountsHolidaysWrapper.classList.toggle('is-active',discountsHolidaysWrapper.hasAttribute('is-active'));
      }
    }, 500);
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
